import React from "react";
import { useState, useContext } from "react";
import examBoard from "../../assets/icons/noticeboard.png";
import { AnimatePresence, motion } from "framer-motion";
import { AiOutlineDelete } from "react-icons/ai";
import { format } from "date-fns";
import { useEffect } from "react";
import { MdDoneAll, MdOutlineDownloadDone, MdRemoveDone } from "react-icons/md";
import Loading from "../../Shared/Loading";
import { NoticeContext } from "../../App";
import { BiEdit } from "react-icons/bi";
import DeleteModalConfirm from "../Modul/DeleteModalConfirm";
import UpdateExamStatus from "../Modul/updateExamStatus";
import CreateNotice from "../Modul/CreateNotice";
import { BsArrowReturnLeft } from "react-icons/bs";

const NoticeBoard = () => {
  const [notices, noticeLoading, noticeRefetch] = useContext(NoticeContext);
  const [design, setDesign] = useState("xm1");
  const [exams, setExams] = useState(notices);
  const [examClass, setExamClass] = useState("Six");
  const [openCreateNotice, setOpenCreateNotice] = useState(null);
  const [deletingModal, setDeletingModal] = useState(null);
  const [openUpdateExam, setOpenUpdateExam] = useState(null);
  const method = "notice";

  const handleState = (i, x) => {
    setExams(i);
    setDesign(x);
  };

  const exms = notices?.filter((i) => i?.examClass?.includes(examClass));

  const xmPending = notices?.filter((i) => i?.status?.includes("pending"));
  const xmRunning = notices?.filter((i) => i?.status?.includes("running"));
  const xmComplete = notices?.filter((i) => i?.status?.includes("complete"));

  useEffect(() => {
    setExams(xmPending);
  }, [notices]);

  if (noticeLoading) {
    return <Loading />;
  }

  return (
    <div className="w-full sm:p-0 p-2">
      <div className="text-center w-full flex items-center justify-between p-3 py-4 shadow-md sm:mb-5 mb-3 rounded-md bg-white">
        <div className="">
          <label
            onClick={() => setOpenCreateNotice([null, "create"])}
            htmlFor="create-notice"
            className="btn btn-primary rounded-3xl btn-sm text-white"
          >
            Create Notice
          </label>
        </div>
        <h1 className="font-bold text-xl">
          <span className="text-accent ">{notices?.length}</span>
        </h1>
        <select
          required
          className="input input-bordered bg-transparent input-sm input-primary w-[100px]"
          onChange={(e) => setExamClass(e.target.value)}
        >
          <option value="All" select>
            All
          </option>
          <option value="Play">Play</option>
          <option value="Nursery">Nursery</option>
          <option value="One">One</option>
          <option value="Two">Two</option>
          <option value="Three">Three</option>
          <option value="Four">Four</option>
          <option value="Five">Five</option>
          <option value="Six">Six</option>
          <option value="Seven">Seven</option>
          <option value="Eight">Eight</option>
          <option value="Nine">Nine</option>
          <option value="Ten">Ten</option>
          <option value="Others">Others</option>
        </select>
      </div>
      <div className="w-full bg-white p-2 sm:p-3 rounded-md shadow-md">
        <div className="w-full flex items-center justify-between ">
          <div
            onClick={() => handleState(xmPending, "xm1")}
            className={`${
              design === "xm1"
                ? "bg-gradient-to-r from-[#13b38f] to-[#2091d9] duration-100 rounded-md !text-white"
                : "border bg-slate-100"
            } relative overflow-hidden cursor-pointer w-full py-2 px-0`}
          >
            <div className="text-center">
              <h1 className="text-[16px] mt-3 sm:mt-0 py-1">Pending</h1>
            </div>
            <div
              className={`${
                design === "xm1" ? "bg-secondary" : "bg-[#a09f9f]"
              } absolute -top-1.5 grid place-content-center -left-1.5 w-10 h-7 rounded-full text-white`}
            >
              <p className="text-sm mt-1">{xmPending?.length}</p>
            </div>
          </div>
          <div
            onClick={() => handleState(xmRunning, "xm2")}
            className={`${
              design === "xm2"
                ? "bg-gradient-to-r from-[#13b38f] to-[#2091d9] duration-100 rounded-md !text-white"
                : "border bg-slate-100"
            } relative overflow-hidden cursor-pointer w-full py-2 px-0`}
          >
            <div className="text-center">
              <h1 className="text-[16px] mt-3 sm:mt-0 py-1">Running</h1>
            </div>
            <div
              className={`${
                design === "xm2" ? "bg-secondary" : "bg-[#a09f9f]"
              } absolute -top-1.5 grid place-content-center -left-1.5 w-10 h-7 rounded-full text-white`}
            >
              <p className="text-sm mt-1">{xmRunning?.length}</p>
            </div>
          </div>
          <div
            onClick={() => handleState(xmComplete, "xm4")}
            className={`${
              design === "xm4"
                ? "bg-gradient-to-r from-[#13b38f] to-[#2091d9] duration-100 rounded-md !text-white"
                : "border bg-slate-100"
            } relative overflow-hidden cursor-pointer w-full py-2 px-0`}
          >
            <div className="text-center">
              <h1 className="text-[16px] mt-3 sm:mt-0 py-1">Complete</h1>
            </div>
            <div
              className={`${
                design === "xm4" ? "bg-secondary" : "bg-[#a09f9f]"
              } absolute -top-1.5 grid place-content-center -left-1.5 w-10 h-7 rounded-full text-white`}
            >
              <p className="text-sm mt-1">{xmComplete?.length}</p>
            </div>
          </div>
        </div>
      </div>
      <motion.div
        layout
        className="md:mt-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-5 mt-3"
      >
        <AnimatePresence>
          {exams?.map((i, index) => (
            <>
              <motion.div
                layout
                key={i?._id}
                animate={{ opacity: 1, scale: 1 }}
                initial={{ opacity: 0, scale: 0 }}
                exit={{ opacity: 0, scale: 0 }}
                className={`${
                  i?.status === "pending"
                    ? "border-[#dfdddd]"
                    : "border-secondary"
                } 
                        ${
                          i?.status === "complete"
                            ? "border-[#8df3f9] "
                            : "border-secondary"
                        }  
                        p-2 md:mt-0 w-full relative overflow-hidden cursor-pointer border-[3px] border-secondary bg-white  duration-300 shadow-md rounded-2xl`}
              >
                <div className="border-b-2 py-1.5 pb-0.5 gap-2">
                  <div className="w-full flex gap-2">
                    <div className="w-10">
                      <img src={examBoard} className="w-10" alt="pending " />
                    </div>
                    <div className="w-full">
                      <h3 className="text-[16px] capitalize element-font-5 font-bold">
                        {i?.noticeTitle}
                      </h3>
                      <p className="text-[12px] element-font-5">
                        {i?.description}
                      </p>
                    </div>
                  </div>
                  {/* <div className='flex items-center justify-between'>
                                    <p className='text-[12px]'>{format(new Date(i?.createdAt), 'PP')}</p>
                                    <h5 className='text-right capitalize text-[#2c536e] font-bold'>{i?.status}...</h5>
                                </div> */}
                  {/* <div className={`${(i?.status === "pending")? "bg-[#dedede] text-primary" : ""}
                                ${(i?.status === "complete")? "bg-[#8df3f9] text-secondary" : ""}
                                absolute -top-1.5 grid place-content-center -right-1.5 w-[68px] h-7 rounded-full bg-secondary text-white`}>
                                    <p className='text-sm text-purple-700 mt-1'>{i?.noticeClass}</p>
                                </div>    */}
                </div>
                <div className="flex items-end justify-between mt-1.5">
                  <div></div>
                  <div className="flex items-center">
                    {i?.status === "pending" && (
                      <label
                        onClick={() => setOpenUpdateExam([i, "running"])}
                        htmlFor="Update-Exam"
                        className="text-primary mr-2 cursor-pointer"
                      >
                        <span className="text-gray-500">
                          <MdRemoveDone size={20} />
                        </span>
                      </label>
                    )}
                    {/* {(i?.status === "running") && <label onClick={() => setOpenUpdateExam([i, "processing"])} htmlFor='Update-Exam' className="text-primary mr-2 cursor-pointer">
                                        <span className='text-gray-500'><MdRemoveDone size={20} /></span>
                                    </label>
                                    } */}
                    {i?.status === "running" && (
                      <label
                        onClick={() => setOpenUpdateExam([i, "complete"])}
                        htmlFor="Update-Exam"
                        className="text-primary mr-2 cursor-pointer"
                      >
                        <span className="text-gray-500">
                          <MdRemoveDone size={20} />
                        </span>
                      </label>
                    )}
                    {i?.status === "complete" && (
                      <label
                        onClick={() => setOpenUpdateExam([i, "running"])}
                        htmlFor="Update-Exam"
                        className="mr-2 cursor-pointer"
                      >
                        <span className="text-gray-500">
                          <BsArrowReturnLeft size={20} />
                        </span>
                      </label>
                    )}
                    {(i?.status === "running" ||
                      i?.status === "complete" ||
                      i?.status === "processing") && (
                      <div className="mr-2">
                        <span className="text-green-500">
                          <MdDoneAll size={20} />
                        </span>
                      </div>
                    )}
                    {i?.status === "processing" && (
                      <div className="mr-2">
                        <span className="text-green-500">
                          <MdDoneAll size={20} />
                        </span>
                      </div>
                    )}
                    <label
                      onClick={() => setOpenCreateNotice([i, "update"])}
                      htmlFor="create-notice"
                      className="text-primary cursor-pointer"
                    >
                      <BiEdit size={20} />
                    </label>
                    {(i?.status === "pending" ||
                      i?.status === "complete" ||
                      i?.status === "running") && (
                      <label
                        onClick={() => setDeletingModal(i)}
                        htmlFor="delete-confirm-modal"
                        className="text-accent ml-2 cursor-pointer"
                      >
                        <AiOutlineDelete size={20} />
                      </label>
                    )}
                  </div>
                </div>
              </motion.div>
            </>
          ))}
        </AnimatePresence>
      </motion.div>
      {openCreateNotice && (
        <CreateNotice
          openCreateNotice={openCreateNotice}
          refetch={noticeRefetch}
          setOpenCreateNotice={setOpenCreateNotice}
        />
      )}
      {openUpdateExam && (
        <UpdateExamStatus
          openUpdateExam={openUpdateExam}
          refetch={noticeRefetch}
          setOpenUpdateExam={setOpenUpdateExam}
          method={method}
        />
      )}
      {deletingModal && (
        <DeleteModalConfirm
          deletingModal={deletingModal}
          setDeletingModal={setDeletingModal}
          refetch={noticeRefetch}
          method={method}
        />
      )}
    </div>
  );
};

export default NoticeBoard;
